
import { useTranslation } from 'react-i18next';
import { useInjectedCounter } from './InjectedCounter.hook';

export const InjectedCounter: React.FC = () => {
  const { count, handleIncrement, handleDecrement } = useInjectedCounter();
  const { t } = useTranslation();

  return (
    <div className="mt-4 p-4 rounded-xl bg-white/5 border border-white/5">
      <div className="flex justify-between items-center mb-3">
        <span className="text-sm text-primary-accent font-bold">
          {t('injectedState')}:
        </span>
        <span className="text-xl text-white font-mono font-bold">
          {count ?? 'Not Injected'}
        </span>
      </div>
      <div className="flex gap-2">
        <button
          onClick={handleIncrement}
          className="grow bg-primary-accent text-bg-deep dark:text-black hover:opacity-90 active:scale-95 transition-all text-xs font-bold py-2 px-3 rounded-lg cursor-pointer"
        >
          + {t('increment')}
        </button>
        <button
          onClick={handleDecrement}
          className="grow bg-white/10 text-white hover:bg-white/20 active:scale-95 transition-all text-xs font-bold py-2 px-3 rounded-lg border border-white/10 cursor-pointer"
        >
          - {t('decrement')}
        </button>
      </div>
    </div>
  );
};
export default InjectedCounter;
